import { useIsBreakpoint } from '@/hooks/useIsBreakpoint';

export const useIsColumnLayout = () => {
  const isColumnLayout = useIsBreakpoint('lg');
  return { isColumnLayout };
};
